import { Outlet } from 'react-router-dom';

const RegistrationLayout = () => {
  return <Outlet />;
};

export default RegistrationLayout;
